/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
export default {
    setUsers(state, data) {
        state.users = data
    },
    setUsersFilters(state, data) {
        state.usersFilters = data
    },
    setCitizens(state, data) {
        state.citizens = data
    },
    setNewCitizen(state, data) {
        state.newCitizen = data
    },
    setNewUser(state, data) {
        state.newUser = data
    },
    setNewWebhook(state, data) {
        state.newWebhook = data
    },
    setCompany(state, { company }) {
        state.company = company
    },
    setCompanySettings(state, company) {
        state.companySettings = company
    },
    SetCompanyHeaderMail(state, company) {
        state.companyHeaderMail = company
    }
}
